enum Handlers {
  GEORGE_WASHINGTON = 'George_Washington',
  THOMAS_JEFFERSON = 'Thomas_Jefferson',
  JAMES_MADISON = 'James_Madison',
  JAMES_MONROE = 'James_Monroe',
  JOHN_ADAMS = 'John_Adams',
  JOHN_QUINCY_ADAMS = 'John_Quincy_Adams',
  ANDREW_JACKSON = 'Andrew_Jackson',
  WILLIAM_HENRY_HARRISON = 'William_Henry_Harrison',
  MARTIN_VAN_BUREN = 'Martin_Van_Buren',
}

export interface HandlerOption {
  value: `${Handlers}`
  label: string
}

export default Handlers
